import { sendBucketEvent } from 'client/javascript/heap';
import { logWarning } from 'client/javascript/util/logger';
import { getExperimentValue, DEFAULT_ELIGIBLE_EXPERIMENT_VALUES } from 'client/javascript/experiments';

export const ALL_ACCESS_PROMO_EXPERIMENT_KEY = 'allaccess_promo_test';

export function setupHomepageAllAccessExperimentBucketing() {
  try {
    const shouldBucket = DEFAULT_ELIGIBLE_EXPERIMENT_VALUES.includes(
      getExperimentValue(ALL_ACCESS_PROMO_EXPERIMENT_KEY)
    );
    if (shouldBucket) {
      sendBucketEvent(ALL_ACCESS_PROMO_EXPERIMENT_KEY);
    }
  } catch (error) {
    logWarning(`[Home page] All Access Promo bucketing event failed: ${error.message}`, error);
  }
}
